<template>
    <div class="tab-wrapper" ref="wrapper">
        <div class="tabs" :class="{ full, outline }">
            <div
                class="tab"
                v-for="(item, index) in headers"
                :key="index"
                :class="{ active: index === activeTab, outline }"
                @click="$emit('change', index)"
                ref="tabs"
            >
                {{ item }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Tabs',
    props: {
        headers: Array,
        activeTab: Number,
        full: {
            type: Boolean,
            default: true,
        },
        outline: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        activeTab(v) {
            let scrollLeft = this.$refs.tabs
                .slice(0, v)
                .reduce((sum, v, i) => (sum += v.offsetWidth), 0);
            if (v > 0) {
                scrollLeft -=
                    (document.documentElement.clientWidth -
                        this.$refs.tabs[v].offsetWidth) /
                    2;
            }
            scrollLeft = Math.max(scrollLeft, 0);
            this.$refs.wrapper.scrollTo({
                top: 0,
                left: scrollLeft,
                behavior: 'smooth',
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';

.tab-wrapper {
    background: white;
    width: 100%;
    overflow: scroll;

    &::-webkit-scrollbar {
        /* chrome based */
        width: 0;
        height: 0; /* ширина scrollbar'a */
        background: transparent; /* опционально */
    }

    -ms-overflow-style: none; /* IE 10+ */
    scrollbar-width: none; /* Firefox */

    .tabs {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        height: 40px;
        @include on-md {
            height: 40px;
            min-width: 768px;
        }
        @include on-sm {
            height: 40px;
            min-width: 768px;
        }
        .tab {
            font-style: normal;
            font-weight: 600;
            font-size: 14px;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 0 28px;
            border-bottom: 2px solid transparent;
            cursor: pointer;

            &.outline {
                margin-bottom: -2px;
            }
        }
        .active {
            border-bottom: 2px solid #4663ab;
            color: #4663ab;
        }
    }
    .full {
        justify-content: space-between;
    }
    .outline {
        border-bottom: 2px solid #f3f3f3;
    }
}
</style>
